import ValuesImage from "../../images/about-us/values-bg-image.png";

function AboutValues({ ref, visible }) {
  return (
    <div className="about-us-values">
      <h1>The values that keeps us grounded</h1>
      <p>
        At <span style={{ fontWeight: "bold" }}>BrandOne</span>, we believe
        great solutions start with great relationships. We listen closely, think
        creatively, and stay hands-on from idea to execution. Every project is a
        shared journey — built with care, driven by purpose, and designed to
        truly work for the people who use it.
      </p>
      <img src={ValuesImage} alt="bg" className="bg-image" />
      <div className={`frame ${visible ? "visible" : ""}`} ref={ref} />
    </div>
  );
}

export default AboutValues;
